import { FormEvent, ReactNode } from "react";

// Componentes de estrutura compartilhados por todas as telas: título com ações e
// barra de filtros. Ficam fora do App para que as telas extraídas possam usá-los
// sem criar dependência circular com o shell.
export function PageHeader({ eyebrow, title, subtitle, actions }: {
  eyebrow: string;
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}) {
  return (
    <header className="page-header">
      <div className="page-heading">
        <p className="eyebrow">{eyebrow}</p>
        <h1>{title}</h1>
        {subtitle && <p className="muted">{subtitle}</p>}
      </div>
      {actions && <div className="page-actions">{actions}</div>}
    </header>
  );
}

// Barra de filtros comum: rótulo "Filtros", campos e ações (Filtrar/Limpar) agrupados.

export function FilterBar({ children, actions, onSubmit }: {
  children: ReactNode;
  actions?: ReactNode;
  onSubmit?: (event: FormEvent) => void;
}) {
  return (
    <form
      className="panel filter-bar"
      onSubmit={(event) => {
        event.preventDefault();
        onSubmit?.(event);
      }}
    >
      <div className="filter-bar-head">
        <span className="filter-bar-label">Filtros</span>
      </div>
      <div className="filter-bar-fields">{children}</div>
      {actions && <div className="filter-bar-actions">{actions}</div>}
    </form>
  );
}

export function Metric({
  label,
  value,
  tone,
}: {
  label: string;
  value: string | number;
  tone?: string;
}) {
  return (
    <article className={`metric ${tone ?? ""}`}>
      <span>{label}</span>
      <strong>{value}</strong>
    </article>
  );
}
